import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BackgroundEffects } from '@components/common';
import {
  HomePage,
  DonatePage,
  ConsolesPage,
  GamesPage,
  NotFoundPage,
} from '@pages/index';
import '@styles/global.css';

const App: React.FC = () => {
  return (
    <Router>
      <BackgroundEffects />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/consoles" element={<ConsolesPage />} />
        <Route path="/games" element={<GamesPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default App;
